module.exports = __webpack_public_path__ + "static/img/new-icon.ae4acd24.png";